"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = removeComponents;

var _utils = require("./utils");

var _destroyInstance = require("./destroyInstance");

var _destroyInstance2 = _interopRequireDefault(_destroyInstance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Removes instances of components on elements within the context
 * @param context: DOM element
 */

function removeComponents() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;

    (0, _utils.queryAll)('[g-component]', context).forEach(function (element) {
        (0, _destroyInstance2.default)(element);
    });
}



//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/gia/removeComponents.js
// module id = 67
// module chunks = 0